import { LocalStorageConfig } from 'ngrx-store-localstorage';
import { WalkthroughImages } from './models';
import {
  pupilPlanImages,
  pupilPlanPractiseImages,
  pupilPractiseImages,
} from './constants';

export function getLocalStorageConfig(prefix: string): LocalStorageConfig {
  return {
    keys: ['showWalkthrough'],
    rehydrate: true,
    removeOnUndefined: true,
    storageKeySerializer: (key) => `${prefix}/user/${key}`,
  };
}

export function getImagesByPermission(
  planPermission: boolean,
  practisePermission: boolean,
): WalkthroughImages {
  if (planPermission && practisePermission) {
    return pupilPlanPractiseImages;
  }

  if (planPermission) {
    return pupilPlanImages;
  }

  if (practisePermission) {
    return pupilPractiseImages;
  }

  return {
    desktop: [],
    mobile: [],
  };
}
